import { BillClaimCategoryEnum } from './BillClaimCategory';
import { CategoriesEnum } from './Categories';
import { ClaimStatusEnum } from './ClaimStatus';
import { DocumentContentTypeEnum } from './DocumentContentType';
import { DocumentSourceTypeEnum } from './DocumentSourceType';
import { FacilityLocationTypeEnum } from './FacilityLocationType';
import { FocusRequestTypeEnum } from './FocusRequestType';
import { InsurancePlanReferralTypeEnum } from './InsurancePlanReferralType';
import { InsurancePlanStatusTypeEnum } from './InsurancePlanStatusType';
import { InsuranceTypeEnum } from './InsuranceType';
import { InteractionInteractedWithEnum } from './InteractionInteractedWith';
import { InteractionModalityCodeEnum } from './InteractionModalityCode';
import { MemberGenderTypeEnum } from './MemberGenderType';
import { PartnerCardTitleEnum } from './PartnerCardTitle';
import { PlanCategoryTypeEnum } from './PlanCategoryType';
import { ProductOptionsEnum } from './ProductOptions';
import { RibbonHealthEducationTypeEnum } from './RibbonHealthEducationType';
import { RibbonHealthLanguageSearchNameEnum } from './RibbonLanguageName';
import { RibbonHealthSpecialtySearchNameEnum } from './RibbonSpecialtyName';
import { RoadmapImageTypeEnum } from './RoadmapImageType';
import { TicketBenefitCategoryTypeEnum } from './TicketBenefitCategoryType';
import { TicketPriorityEnum } from './TicketPriority';
import { TicketStatePriorityEnum } from './TicketStatePriority';
import { UsStateNameEnum } from './UsStateName';
import { TopicAreaEnum } from './TopicArea';
import { PriorAuthorizationStatusPaStatusEnum } from './PriorAuthorizationStatusPaStatus';
import { PriorAuthorizationStatusRequesterEnum } from './PriorAuthorizationStatusRequester';
import { IssueEnum } from './Issue';
import { QueueSystemAuditLogActionTypeEnum } from './QueueSystemAuditLogActionType';
var enumCollections = {
    BILL_CLAIM_CATEGORY: BillClaimCategoryEnum,
    Categories: CategoriesEnum,
    CLAIM_STATUS: ClaimStatusEnum,
    DOCUMENT_CONTENT_TYPE: DocumentContentTypeEnum,
    DOCUMENT_SOURCE_TYPE: DocumentSourceTypeEnum,
    FACILITY_LOCATION_TYPE: FacilityLocationTypeEnum,
    FOCUS_REQUEST_TYPE: FocusRequestTypeEnum,
    INTERACTION_MODALITY_CODE: InteractionModalityCodeEnum,
    InteractionInteractedWith: InteractionInteractedWithEnum,
    InsuranceType: InsuranceTypeEnum,
    INSURANCE_PLAN_REFERRAL_TYPE: InsurancePlanReferralTypeEnum,
    InsurancePlanStatusType: InsurancePlanStatusTypeEnum,
    MemberGenderType: MemberGenderTypeEnum,
    PARTNER_CARD_TITLE: PartnerCardTitleEnum,
    PlanCategoryType: PlanCategoryTypeEnum,
    ProductOptions: ProductOptionsEnum,
    RIBBON_HEALTH_EDUCATION_TYPE: RibbonHealthEducationTypeEnum,
    RIBBON_HEALTH_LANGUAGE_SEARCH_NAME: RibbonHealthLanguageSearchNameEnum,
    RIBBON_HEALTH_SPECIALTY_SEARCH_NAME: RibbonHealthSpecialtySearchNameEnum,
    ROADMAP_IMAGE_TYPE: RoadmapImageTypeEnum,
    TICKET_BENEFIT_CATEGORY_TYPE: TicketBenefitCategoryTypeEnum,
    TicketPriority: TicketPriorityEnum,
    TICKET_STATE_PRIORITY: TicketStatePriorityEnum,
    TOPIC_AREA: TopicAreaEnum,
    US_STATE_NAME: UsStateNameEnum,
    PRIOR_AUTHORIZATION_STATUS_REQUESTER: PriorAuthorizationStatusRequesterEnum,
    PRIOR_AUTHORIZATION_STATUS_PA_STATUS: PriorAuthorizationStatusPaStatusEnum,
    ELIGIBILITY_ISSUE: IssueEnum,
    QUEUE_SYSTEM_AUDIT_LOG_ACTION_TYPE: QueueSystemAuditLogActionTypeEnum
};
export default enumCollections;
